module.exports = __webpack_public_path__ + "static/media/job-order.f8875c35.svg";